import { CarbonUnit, UnitNumberType } from "../../utils/units/units";
import { CycleSlot, Metric, MetricNumber } from "../../utils/metrics";
import { getSavedUnit } from "./numericUnits";
import { useMeasurement, useSelf } from "../../state/store";
import { useTranslation } from "react-i18next";
import React, { FC } from "react";

/**
 * @returns either the user's saved unit or the default unit for the given cycleSlot
 * and measurementSystem, as well as available units for the cycleSlot.
 **/
export const useSavedUnit = (
  cycleSlot: CycleSlot | undefined,
  unit: CarbonUnit
): { units?: CarbonUnit[]; unit: CarbonUnit } => {
  const { measurementSystem } = useSelf();
  const { cycleSlots } = useMeasurement();
  return getSavedUnit(measurementSystem, cycleSlots, cycleSlot, unit);
};

/**
 * @returns the unit for the given Metric, based on the user's stored preference
 **/
export const MetricUnitSpan: FC<{ metric: Metric }> = ({ metric }) => {
  if (!("units" in metric)) {
    return;
  }
  return <NumericMetricUnitSpan metric={metric} />;
};

const NumericMetricUnitSpan: FC<{ metric: MetricNumber }> = ({ metric }) => (
  <UnitSpan unit={useSavedUnit(metric.cycleSlot, metric.units).unit} />
);

/**
 * @returns a span that renders a unit
 **/
export const UnitSpan: FC<{ unit: CarbonUnit }> = ({ unit }) => {
  const { t } = useTranslation();

  return unit === UnitNumberType.COUNT ? undefined : (
    <span className="font-normal text-xs opacity-50 flex flex-col">
      <span className="flex-1 min-w-1 flex items-center text-nowrap">
        {t(`utils.units.${unit === UnitNumberType.PERCENT ? "%" : unit}`)}
      </span>
    </span>
  );
};
